<ion-content>
  <ion-row>
    <ion-col class="team-sidebar" *ngIf="!isAdminEditMode">
      <app-team-listing-sidebar> </app-team-listing-sidebar>
    </ion-col>
    <ion-col class="team-sidebar profile-sidebar-spacer" *ngIf="isAdminEditMode"></ion-col>
    <ion-col class="user-profile-content">
      <div class="profile-action-row" *ngIf="isAdminEditMode">
        <a class="profile-back-link" [routerLink]="['/users']">Back to User Roster</a>
        <button class="secondary button profile-login-as-user-button" *ngIf="canLoginAsUser" type="button" (click)="loginAsUser()">
          Login as User
        </button>
      </div>
      <ion-title>{{ pageTitle }}</ion-title>
      <p class="profile-copy" *ngIf="!error">{{ pageCopy }}</p>
      <div class="status-panel" *ngIf="isLoading">Loading user profile...</div>
      <div class="status-panel error" *ngIf="error">{{ error }}</div>
      <form
        *ngIf="user && userProfileForm && !isLoading && !error"
        id="user-profile-form"
        [formGroup]="userProfileForm"
        novalidate
      >
        <h4 class="form-subheadline">
          <i class="icon-contact"></i>
          General Information
        </h4>
        <ion-list lines="none" inset>
          <ion-item class="first-name">
            <ion-label color="medium" position="stacked">First Name <span style="color:#f1624a">*</span></ion-label>
            <ion-input type="text" formControlName="userFirstName" inputCapitalizeFirst required></ion-input>
          </ion-item>
          <ion-item class="last-name">
            <ion-label color="medium" position="stacked">Last Name <span style="color:#f1624a">*</span></ion-label>
            <ion-input type="text" formControlName="userLastName" inputCapitalizeFirst required></ion-input>
          </ion-item>
          <div class="user-phone-container">
            <ion-item class="user-phone-country-code">
              <ion-label color="medium" position="stacked">US (+1)</ion-label>
              <ion-input type="text" maxLength="2" formControlName="userPhoneCountryCode" placeholder="1"></ion-input>
            </ion-item>
            <ion-item class="user-phone-area-code">
              <ion-label color="medium" position="stacked">(###)</ion-label>
              <ion-input type="text" maxLength="3" formControlName="userPhoneAreaCode" placeholder="000"></ion-input>
            </ion-item>
            <ion-item class="user-phone-number">
              <ion-label color="medium" position="stacked">Phone #</ion-label>
              <ion-input type="text" formControlName="userPhoneNumber" inputAddPhoneDashes></ion-input>
            </ion-item>
          </div>
          <div class="user-spanish-speaking">
            <ion-label color="medium" class="spanish-label" position="stacked">Do you speak Spanish?</ion-label>
            <ion-radio-group class="followup-form-choice-group" formControlName="userSpeaksSpanish">
              <ion-radio
                class="followup-form-choice followup-form-choice--compact"
                value="1"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Yes
              </ion-radio>
              <ion-radio
                class="followup-form-choice followup-form-choice--compact"
                value="0"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                No
              </ion-radio>
            </ion-radio-group>
          </div>
        </ion-list>
        <h4 class="form-subheadline">
          <i class="icon-birthday"></i>
          Get to know you...
        </h4>
        <ion-list class="get-to-know-you" lines="none">
          <ion-item class="user-dob">
            <ion-label color="medium" position="stacked">Birthday <span style="color:#f1624a">*</span></ion-label>
            <ion-input
              type="text"
              inputmode="numeric"
              autocomplete="bday"
              placeholder="mm/dd/yyyy"
              formControlName="userDob"
            ></ion-input>
          </ion-item>
          <ion-item class="user-dessert">
            <ion-label color="medium" position="stacked">Favorite Dessert</ion-label>
            <ion-input type="text" formControlName="userFavoriteDessert"></ion-input>
          </ion-item>
        </ion-list>
        <ion-list lines="none" inset class="checkbox-list-container">
          <div class="checkbox-section checkbox-question" formGroupName="userInterests">
            <ion-label class="main-label-box checkbox-question-title" color="medium" position="stacked">
              Do any of the following apply to you?
            </ion-label>
            <div class="checkbox-grid" role="group" aria-label="User interests checklist">
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="celebrity"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Met your favorite celebrity
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="helicopter"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Flown in a helicopter
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="kidney"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Donated a kidney
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="skydivedOrBungeed"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Skydived or bungee jumped
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="appearedOnTv"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Appeared on TV
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="janeAusten"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Read Pride &amp; Prejudice
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="escargo"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Eaten Escargo
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="deployed"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Been deployed
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="instrument"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Played an instrument
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="seenTornado"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Seen a tornado
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="hitchhiked"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Hitchhiked
              </ion-checkbox>
              <ion-checkbox
                class="checkbox-option followup-form-choice followup-form-choice--compact"
                formControlName="DND"
                labelPlacement="end"
                alignment="start"
                justify="start"
              >
                Played Dungeons &amp; Dragons
              </ion-checkbox>
            </div>
          </div>
        </ion-list>
        <div class="user-profile-more-container">
          <ion-list lines="none">
            <ion-item>
              <ion-label class="main-label-box" color="medium" position="stacked"
                >Anything else you want to share with the team?</ion-label
              >
              <ion-textarea formControlName="userAdditionalInfo"></ion-textarea>
            </ion-item>
          </ion-list>
        </div>
        <button class="save primary button" (click)="updateUserProfile()" type="button" [disabled]="isSaving">
          Save
        </button>
        <button class="cancel secondary button" (click)="cancelUpdateProfile()" type="button">
          Cancel
        </button>
      </form>
    </ion-col>
    <ion-col class="avatar-col">
      <div class="avatar-container" *ngIf="user">
        <app-user-avatar [user]="user"></app-user-avatar>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
